export const REPARTIDORES_REQUEST = "REPARTIDORES_REQUEST";
export const REPARTIDORES_REFRESH = "REPARTIDORES_REFRESH";
export const REPARTIDORES_OK = "REPARTIDORES_OK";
export const REPARTIDORES_ERROR = "REPARTIDORES_ERROR";
